import { trigger, state, style, transition, animate, keyframes } from '@angular/animations';

export const loginSucc = trigger('loginSucc', [
  state('in', style({transition: 'all 5s ease-in-out'})),
  transition('void => *', [
       animate(1000, keyframes([
        style({top: '0%'}),
      ]))
]),
  transition('* => void', [
        animate(1000, keyframes([
        style({top: '25%'}),
      ]))
  ])
]);



// WEBPACK FOOTER //
// D:/cpc/sinocc.web/web.X6/www/x6.ng2/src/app/animations/loginSucc.ts